<template>
	<div>
		<div class="relative">
			<div
				v-if="isLabelShow"
				class="user-profile-dadata-input-label"
			>
				{{ label }}
			</div>
			<div
				:class="`formulate-input-element formulate-input-element--${context.class}`"
				:data-type="context.type"
			>
				<div class="custom-dadata-company--input">
					<DaDataInput
						:key="context.model"
						:value="model"
						:name="context.attributes.name"
						:input-name="context.attributes.name ?? ''"
						:suggest-type="'party'"
						:set-label="setLabel"
						:da-data-item="DaDataCompanyItem"
						:request-options="context.attributes['request-options']"
						:initial-value="context.model"
						:input-options="context.attributes.input_options"
						:style-classes="context.attributes['style-classes']"
						:is-set-initial-value="true"
						:is-own-type-value="true"
						@input="inputHandler"
						@blur="context.blurHandler"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DaDataCompanyItem from '~/components/daData/DadataItems/DaDataCompanyItem.vue';
import DaDataInput from '~/components/DaDataInput.vue';

export default {
	components: {
		DaDataInput,
	},
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			model: null,
			DaDataCompanyItem,
		};
	},
	computed: {
		isLabelShow() {
			if (this.context.attributes.is_label_hide) return false;
			return true;
		},
		required() {
			return !!this.context.rules.find((el) => el.ruleName === 'required');
		},
		label() {
			const label = this.context.attributes['label-text'];
			const required = this.required ? '*' : '';

			return label ? `${label}${required}` : '';
		},
	},
	methods: {
		inputHandler(dadataValue) {
			if (!dadataValue) {
				this.context.model = null;
				this.context.rootEmit('setCompanyInfo', null);
				return;
			}

			const { data } = dadataValue;
			if (data) {
				this.model = data['inn'];
				this.context.model = data['inn'];
				this.context.rootEmit('setCompanyInnInfo', dadataValue);
			}
		},
		setLabel(item) {
			if (item.data) {
				return `${item.data['inn']}`;
			}
			return `${item}`;
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.user-profile-dadata-input-label {
	font-weight: 500;
	line-height: 1.2;
	margin-bottom: 0.5rem;
}

</style>
<style lang="scss">

.user-profile-dadata-input {
	& .vs__input {
		border-radius: 0 !important;
		border: 1px solid #949ABA !important;
		font-size: 1rem !important;
		padding: 1.3rem 1rem 1.3rem 1rem !important;
		line-height: 1.5rem !important;
		height: calc(1.5em + 0.75rem + 2px);
		font-family: "Raleway", sans-serif;
		font-weight: 500;

		&::placeholder {
			font-weight: 300;
			color: #959BBA;
		}
	}
}
</style>
